var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C384C",
    fillRule: "nonzero",
    d: "M23.68 0l2.826 2.814-8.975 8.938-2.826-2.814L23.68 0zM0 2.698h16.475l-2.857 2.845H2.856v18.861h15.236V15.67l2.856-2.845V27.25H0V2.698zm11.909 11.839l1.449-5.052 3.625 3.609-5.074 1.443zM4.625 7.984h7v2h-7v-2zm0 12h11v2h-11v-2zm0-4h6.322v2H4.625v-2zm0-4h4.322v2H4.625v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.568f5f43016fbe0acdb2f388d29812e2.svg";
export { ForwardRef as ReactComponent };